import { ApiCollection }                                     from 'Collections/ApiCollection';
import { PagedCollection }                                   from 'Collections/PagedCollection';
import EventModel                                            from 'Models/auditer/EventModel';
import CommentModel                                          from 'Models/comment/CommentModel';
import ContactModel                                          from 'Models/directory/ContactModel';
import FileModel                                             from 'Models/file/FileModel';
import InterventionModel                                     from 'Models/intervention/InterventionModel';
import InterventionStatusModel                               from 'Models/intervention/InterventionStatusModel';
import OperationCategoryModel                                from 'Models/intervention/OperationCategoryModel';
import OperationModel                                        from 'Models/intervention/OperationModel';
import TaskGroupModel                                        from 'Models/intervention/TaskGroupModel';
import TaskModel                                             from 'Models/intervention/TaskModel';
import TaskOperationModel                                    from 'Models/intervention/TaskOperationModel';
import TaskOperationStatusModel                              from 'Models/intervention/TaskOperationStatusModel';
import TaskStatusModel                                       from 'Models/intervention/TaskStatusModel';
import TaskZoneGroupModel                                    from 'Models/intervention/TaskZoneGroupModel';
import TaskZoneModel                                         from 'Models/intervention/TaskZoneModel';
import ZoneContactModel                                      from 'Models/intervention/ZoneContactModel';
import BillableItemModel                                     from 'Models/invoice/BillableItemModel';
import BillableModel                                         from 'Models/invoice/BillableModel';
import BillableStatusModel                                   from 'Models/invoice/BillableStatusModel';
import BillingFrequencyModel                                 from 'Models/invoice/BillingFrequencyModel';
import BillingGroupModel                                     from 'Models/invoice/BillingGroupModel';
import CurrencyModel                                         from 'Models/invoice/CurrencyModel';
import DebitMandateModel                                     from 'Models/invoice/DebitMandateModel';
import InvoiceModel                                          from 'Models/invoice/InvoiceModel';
import InvoiceStatusModel                                    from 'Models/invoice/InvoiceStatusModel';
import InvoiceTypeModel                                      from 'Models/invoice/InvoiceTypeModel';
import InvoicingGroupModel                                   from 'Models/invoice/InvoicingGroupModel';
import PaymentModeModel                                      from 'Models/invoice/PaymentModeModel';
import PaymentModeRuleModel                                  from 'Models/invoice/PaymentModeRuleModel';
import PaymentModeTypeModel                                  from 'Models/invoice/PaymentModeTypeModel';
import VatModel                                              from 'Models/invoice/VatModel';
import NotificationModel                                     from 'Models/notification/NotificationModel';
import StaffMemberModel                                      from 'Models/rh/StaffMemberModel';
import StaffModel                                            from 'Models/rh/StaffModel';
import ActivityCategoryModel                                 from 'Models/sales/ActivityCategoryModel';
import ActivityModel                                         from 'Models/sales/ActivityModel';
import ActivityTypeModel                                     from 'Models/sales/ActivityTypeModel';
import ChargeableModeModel                                   from 'Models/sales/ChargeableModeModel';
import ChargeableModel                                       from 'Models/sales/ChargeableModel';
import ContractActorGroupModel                               from 'Models/sales/ContractActorGroupModel';
import ContractActorModel                                    from 'Models/sales/ContractActorModel';
import ContractIterationBillingGroupModel                    from 'Models/sales/ContractIterationBillingGroupModel';
import ContractIterationClosingModel                         from 'Models/sales/ContractIterationClosingModel';
import ContractIterationItemActivityChargeableModel          from 'Models/sales/ContractIterationItemActivityChargeableModel';
import ContractIterationItemActivityModel                    from 'Models/sales/ContractIterationItemActivityModel';
import ContractIterationItemEventItemActivityModel           from 'Models/sales/ContractIterationItemEventItemActivityModel';
import ContractIterationItemEventModel                       from 'Models/sales/ContractIterationItemEventModel';
import ContractIterationItemModel                            from 'Models/sales/ContractIterationItemModel';
import ContractIterationItemScheduleConstraintModel          from 'Models/sales/ContractIterationItemScheduleConstraintModel';
import ContractIterationModel                                from 'Models/sales/ContractIterationModel';
import ContractIterationReconductionModel                    from 'Models/sales/ContractIterationReconductionModel';
import ContractIterationStatusHistoryModel                   from 'Models/sales/ContractIterationStatusHistoryModel';
import ContractIterationStatusModel                          from 'Models/sales/ContractIterationStatusModel';
import ContractIterationSummaryCalculateProjectedModel       from 'Models/sales/ContractIterationSummaryCalculateProjectedModel';
import ContractIterationSummaryModel                         from 'Models/sales/ContractIterationSummaryModel';
import ContractOptionTypeModel                               from 'Models/sales/ContractOptionTypeModel';
import ContractOriginModel                                   from 'Models/sales/ContractOriginModel';
import PurchaseOrderTargetModel                              from 'Models/sales/PurchaseOrderTargetModel';
import ReconductabilityModel                                 from 'Models/sales/ReconductabilityModel';
import TagModel                                              from 'Models/sales/TagModel';
import ValidationThresholdModel                              from 'Models/sales/ValidationThresholdModel';
import { BILLABLE_STATUS_CREATED }                           from 'constants/BillableStatuses';
import nestedResolvable                                      from 'decorators/nestedResolvable';
import { action }                                            from 'mobx';
import { computed }                                          from 'mobx';
import { observable }                                        from 'mobx';
import { makeObservable }                                    from 'mobx';
import AbstractModelXStore                                   from 'stores/AbstractModelXStore';
import { appStore }                                          from 'stores';
import { enterprisePropertiesStore }                         from 'stores';
import { authenticationStore }                               from 'stores';
import { groupCollectionByProperty }                         from 'tools/CollectionHelper';
import { indexCollectionByProperty }                         from 'tools/CollectionHelper';
import ConfigProxy                                           from 'tools/ConfigProxy';
import { Rights }                                            from 'tools/Rights';
import { getIdFromUrn }                                      from 'tools/UrnTools';
import { whenAsync }                                         from 'tools/modelxTools';

export default class ContractIterationDashboardStore extends AbstractModelXStore {

	public accReportingRecipientContractActorCollection = new ApiCollection(ContractActorModel);
	public accReportingRecipientContractActorContactCollection = new ApiCollection(ContactModel);
	public activityCategoryCollection = new ApiCollection(ActivityCategoryModel);
	public activityCategorySecondaryCollection = new ApiCollection(ActivityCategoryModel);
	public activityCollection = new ApiCollection(ActivityModel);
	public activityTypeCollection = new ApiCollection(ActivityTypeModel);
	public allInvoiceInvoiceCollection = new ApiCollection(InvoiceModel);
	public allInvoiceRefundCollection = new ApiCollection(InvoiceModel);
	public billableCollection = new ApiCollection(BillableModel);
	public billableItemCollection = new ApiCollection(BillableItemModel);
	public billableStatusCollection = new ApiCollection(BillableStatusModel);
	public billingFrequencyCollection = new ApiCollection(BillingFrequencyModel);
	public billingGroupCollection = new ApiCollection(BillingGroupModel);
	public buyingContractActorCollection = new ApiCollection(ContractActorModel);
	public buyingContractActorContactCollection = new ApiCollection(ContactModel);
	public chargeableCollection = new ApiCollection(ChargeableModel);
	public chargeableModeCollection = new ApiCollection(ChargeableModeModel);
	public commentSpecialConditionsCollection = new ApiCollection(CommentModel);
	public commercialContractActorCollection = new ApiCollection(ContractActorModel);
	public commercialStaffCollection = new ApiCollection(StaffModel);
	public commercialStaffMemberCollection = new ApiCollection(StaffMemberModel);
	public contractActorGroupCollection = new ApiCollection(ContractActorGroupModel);
	public contractIteration = new ContractIterationModel();
	public contractIterationBillingGroup = new ContractIterationBillingGroupModel();
	public contractIterationClosingCollection = new ApiCollection(ContractIterationClosingModel);
	public contractIterationCollection = new ApiCollection(ContractIterationModel);
	public contractIterationDuplicated = new ContractIterationModel();
	public contractIterationDuplicationOriginTagCollection = new ApiCollection(TagModel);
	public contractIterationItemActivityChargeableCollection = new ApiCollection(ContractIterationItemActivityChargeableModel);
	public contractIterationItemActivityCollection = new ApiCollection(ContractIterationItemActivityModel);
	public contractIterationItemActivityTagCollection = new ApiCollection(TagModel);
	public contractIterationItemCollection = new ApiCollection(ContractIterationItemModel);
	public contractIterationItemEventCollection = new ApiCollection(ContractIterationItemEventModel);
	public contractIterationItemEventDonePendingCollection = new ApiCollection(ContractIterationItemEventModel);
	public contractIterationItemEventItemActivityCollection = new ApiCollection(ContractIterationItemEventItemActivityModel);
	public contractIterationItemEventToArbitrateCollection = new PagedCollection(ContractIterationItemEventModel);
	public contractIterationItemScheduleConstraintCollection = new ApiCollection(ContractIterationItemScheduleConstraintModel);
	public contractIterationReconductionAsReconductedCollection = new ApiCollection(ContractIterationReconductionModel);
	public contractIterationReconductionAsReconductionCollection = new ApiCollection(ContractIterationReconductionModel);
	public contractIterationStatusCollection = new ApiCollection(ContractIterationStatusModel);
	public contractIterationStatusHistoryCollection = new ApiCollection(ContractIterationStatusHistoryModel);
	public contractIterationSummaryCollection = new ApiCollection(ContractIterationSummaryModel);
	public contractOptionTypeCollection = new ApiCollection(ContractOptionTypeModel);
	public contractOriginCollection = new ApiCollection(ContractOriginModel);
	public currencyCollection = new ApiCollection(CurrencyModel);
	public debitMandateCollection = new ApiCollection(DebitMandateModel);
	public eventCollection = new PagedCollection(EventModel);
	public interventionCollection = new ApiCollection(InterventionModel);
	public interventionStatusCollection = new ApiCollection(InterventionStatusModel);
	public invoiceInvoiceCollection = new PagedCollection(InvoiceModel);
	public invoiceRefundCollection = new PagedCollection(InvoiceModel);
	public invoiceStatusCollection = new ApiCollection(InvoiceStatusModel);
	public invoiceTypeCollection = new ApiCollection(InvoiceTypeModel);
	public invoicingGroup = new InvoicingGroupModel();
	public notificationCollection = new PagedCollection(NotificationModel);
	public operationCategoryCollection = new ApiCollection(OperationCategoryModel);
	public operationCollection = new ApiCollection(OperationModel);
	public paymentModeCollection = new ApiCollection(PaymentModeModel);
	public paymentModeRuleCollection = new ApiCollection(PaymentModeRuleModel);
	public paymentModeTypeCollection = new ApiCollection(PaymentModeTypeModel);
	public proofConventionFileCollection = new ApiCollection(FileModel);
	public purchaseOrderTargetCollection = new ApiCollection(PurchaseOrderTargetModel);
	public reconductabilityCollection = new ApiCollection(ReconductabilityModel);
	public staffCollection = new ApiCollection(StaffModel);
	public staffMemberCollection = new ApiCollection(StaffMemberModel);
	public taskCollection = new ApiCollection(TaskModel);
	public taskGroupCollection = new ApiCollection(TaskGroupModel);
	public taskOperationCollection = new ApiCollection(TaskOperationModel);
	public taskOperationStatusCollection = new ApiCollection(TaskOperationStatusModel);
	public taskStatusCollection = new ApiCollection(TaskStatusModel);
	public taskZoneCollection = new ApiCollection(TaskZoneModel);
	public taskZoneGroupCollection = new ApiCollection(TaskZoneGroupModel);
	public validationThresholdCollection = new ApiCollection(ValidationThresholdModel);
	public vatCollection = new ApiCollection(VatModel);
	public zoneContactCollection = new ApiCollection(ZoneContactModel);

	private _contractIterationId;

	@observable
	private _itemListNeedsReload = false;

	@observable
	private _marginNeedsReload = false;

	@observable
	private _participationNeedsReload = false;

	public constructor() {
		super();

		makeObservable(this);
	}

	public async checkHasDebitMandate(invoicingGroupUrn: Urn) {
		const enterpriseUrn = this.owner.company.enterprise.urn;
		await this.debitMandateCollection
			.clear()
			.setFilters({
				'invoicingGroup': invoicingGroupUrn,
				'invoicingGroup.invoicingOwner.enterpriseUrn': enterpriseUrn,
				'partitionUrn': ConfigProxy.get('PARTITION_URN'),
			})
			.list();

		return !!this.debitMandateCollection.length;
	}

	public async checkIsAllowedDebit(invoicingGroupUrn: Urn) {
		const hasDebitMandate = await this.checkHasDebitMandate(invoicingGroupUrn);

		if (hasDebitMandate) {
			await this.debitMandateCollection.whenIsLoaded(m => m.debitMandateStatus);

			return this.debitMandateCollection
				.some(debitMandate => debitMandate.debitMandateStatus.reference === 'actif');
		}

		return false;
	}

	public clear() {
		return super.clear();
	}

	public listActivities = async (): Promise<void> => {
		const contractIterationId = this._contractIterationId;

		this.contractIterationItemActivityChargeableCollection.setFilter('contractIterationItemActivity.contractIterationItem.contractIteration', contractIterationId);
		this.contractIterationItemActivityChargeableCollection.list().then();

		this.contractIterationItemActivityCollection.setFilter('contractIterationItem.contractIteration', contractIterationId);
		this.contractIterationItemActivityCollection.setSort('contractIterationItem.position');
		this.contractIterationItemActivityCollection.setSort('position');
		await this.contractIterationItemActivityCollection.list().then(async () => {
			this.activityCollection
				.listBy(this.contractIterationItemActivityCollection.map(m => m.getId('activity')))
				.then(async () => {
					const activityTypeIds = this.activityCollection.map(m => m.getId('activityType'));
					await this.activityTypeCollection.listBy(activityTypeIds);
					await this.activityCategorySecondaryCollection.listBy(activityTypeIds, 'activityTypes');

					const activityTypeUrns = this.activityTypeCollection.map(at => at.urn);

					await this.operationCollection.listBy(activityTypeUrns, 'operationType.sourceUrn');
					await this.operationCollection.whenIsLoaded(o => o.operationType);
				});

			await this.taskZoneCollection
				.listBy(this.contractIterationItemActivityCollection.map(m => m.getId('location')))
				.then(() => {
					this.zoneContactCollection
						.setFilters({
							'contactType.reference': 'signatory',
							taskZone: this.taskZoneCollection.distinctDefinedKey('id'),
						})
						.list();
				});

			await this.taskZoneGroupCollection
				.listBy(this.taskZoneCollection.map(m => m.getId('taskZoneGroup')));

			this.taskZoneGroupCollection.setIsLoaded(true);

			await this.contractIterationItemActivityTagCollection
				.listBy(this.contractIterationItemActivityCollection.urns, 'targetUrn');
		});
	};

	public listEvents = () => {
		const contractIterationId = this._contractIterationId;

		return Promise.all([
			this.contractIterationItemEventCollection
				.setFilter('contractIterationItem.contractIteration', contractIterationId)
				.list()
				.then(() => {
					this.contractIterationItemEventItemActivityCollection
						.listBy(this.contractIterationItemEventCollection.ids, 'contractIterationItemEvent');
				})
				.then(() => {
					this.contractIterationItemEventItemActivityCollection
						.whenIsLoaded(m => m.itemEventItemActivityBillingStatus);
					this.contractIterationItemEventItemActivityCollection
						.whenIsLoaded(m => m.contractIterationItemActivity);
				}),

			this.contractIterationItemEventDonePendingCollection
				.setRequiredFilter('contractIterationItem.contractIteration', contractIterationId)
				.setRequiredFilter('itemEventItemActivities.itemEventItemActivityBillingStatus.reference', 'blocked_to_bill')
				.list(),
		]);
	};

	public listItems = async () => {
		const contractIterationId = this._contractIterationId;

		await this.contractIterationItemCollection
			.setSort('position')
			.setFilter('contractIteration', contractIterationId)
			.list();

		const contractIterationItemsUrns = this.contractIterationItemCollection.distinctDefinedKey('urn');

		if (!contractIterationItemsUrns.length) {
			return;
		}

		await Promise.all([
			this.taskCollection
				.setFilter('taskGroup.sourceUrn', contractIterationItemsUrns)
				.list({
					filterByIdProperty: 'taskGroup.sourceUrn',
				})
				.then(() => {
					return this.taskGroupCollection.listBy(this.taskCollection.map(t => t.getId('taskGroup')));
				}),

			this.taskOperationCollection
				.setRequiredFilter('task.taskHolder.holderUrn', this.contractIteration.urn)
				.list(),
		]);
	};

	public listOptionTypes = () => {
		const contractId = this.contractIteration.contractId;

		return this.contractOptionTypeCollection
			.setFilter('optionType.reference', [
				'measures_subcontracted',
				'measures_uncertainty',
				'report_condition_by_service',
				'report_condition_by_installation',
				'microbiology_results_in_report',
			])
			.listBy([contractId], 'contract')
			.then();
	};

	public listScheduleConstraints = () => {
		const contractIterationId = this._contractIterationId;

		return this.contractIterationItemScheduleConstraintCollection
			.setFilter('contractIterationItem.contractIteration', contractIterationId)
			.list();
	};

	public async load() {
		const contractIterationId = this._contractIterationId;
		//--- ContractIteration, should be first ---//
		await this.contractIteration.setId(contractIterationId).fetch();

		if (!this.contractIteration.isLoaded) {
			return;
		}

		const { contractId } = this.contractIteration;

		await Promise.all([
			whenAsync(() => this.contractIteration.contract.activityCategory.isLoaded),

			this.contractIterationSummaryCollection
				.listBy([contractIterationId], 'contractIteration'),

			this.contractOriginCollection
				.listBy([contractId], 'contract'),

			this.contractIterationClosingCollection
				.listBy([contractIterationId], 'contractIteration'),

			this.commentSpecialConditionsCollection
				.setFilter('typeSource.source.entityUrn', this.contractIteration.urn)
				.setFilter('typeSource.type.reference', 'contract_iteration_special_conditions')
				.list(),

			this.contractIterationCollection
				.setFilter('contract', contractId)
				.setSort('startDate')
				.list(),

			this.contractIterationDuplicationOriginTagCollection
				.setFilter('tag.tagReference.reference', 'contract_iteration_duplication_origin')
				.listBy([this.contractIteration.urn], 'targetUrn')
				.then(async () => {
					const tag = this.contractIterationDuplicationOriginTagCollection.first();
					if (tag) {
						this.contractIterationDuplicated.setId(getIdFromUrn(tag.tagValue));
						await this.contractIterationDuplicated.fetch();
					}
				}),

			this.contractIterationReconductionAsReconductedCollection
				.setFilter('contractIterationReconducted', contractIterationId)
				.list(),

			this.contractIterationReconductionAsReconductionCollection
				.setFilter('contractIterationReconduction', contractIterationId)
				.list(),

			this.eventCollection
				.setFilters({
					'subject.metadata.contract_iteration_urn': this.contractIteration.urn,
					'subject.metadata.recipient_type': 'TO',
				})
				.list(),

			this.notificationCollection
				.listBy([this.contractIteration.urn], 'source.sourceUrn'),

			this.interventionCollection
				.listBy([this.contractIteration.urn], 'interventionOperations.taskOperation.task.taskHolder.holderUrn'),

			this.paymentModeCollection.setFilter('partitionUrn', ConfigProxy.get('PARTITION_URN')).list(),

			this.purchaseOrderTargetCollection.setFilter('targetUrn', this.contractIteration.urn).list(),

			this.reconductabilityCollection.setFilter('contract', contractId).list(),

			whenAsync(() => this.owner.enterprise.isLoaded).then(async () => {
				await enterprisePropertiesStore.initOrLoadMoreAsync([this.owner.enterprise.id]);
				const nafCodeUrn = enterprisePropertiesStore.getEnterprisePropertyValue(this.owner.enterprise.urn, 'naf_code');
				if (nafCodeUrn) {
					await this.paymentModeRuleCollection
						.setFilters({
							'paymentMode.partitionUrn': appStore.partition.urn,
							'targetUrn': nafCodeUrn,
						})
						.list();
				}
			}),

			this.listActivities(),
			this.listEvents(),
			this.listItems(),
			this.listScheduleConstraints(),
			this.loadActorAndContactCollection(),
			this.loadBillingAndInvoicingInformations(),
			this.loadContractIterationStatusHistoryCollection(),
			this.loadInvoiceCollection(),
			this.loadProofConvention(),
			this.loadNotManageableCollections(),
			this.listOptionTypes(),
		]);


		this.validationThresholdCollection.setFilters({
			'ownerSubPartition.subPartitionUrn': appStore.subPartitionUrn,
			staffMemberUrn: authenticationStore.session.ownerUrn,
		});
		await this.validationThresholdCollection.list();
	}

	public loadActorAndContactCollection = async () => {
		const contractId = this.contractIteration.contractId;

		if (!contractId) {
			console.warn('No contract id');
			return;
		}

		await Promise.all([
			this.buyingContractActorCollection
				.setFilters({
					'contract': contractId,
					'contractActorGroup.reference': 'CONTRACT_ACTOR_GROUP_BUYING',
				})
				.list()
				.then(() => {
					return this.buyingContractActorContactCollection
						.listByFromCollection(this.buyingContractActorCollection, 'actorId', 'id');
				}),

			this.commercialContractActorCollection
				.setFilters({
					'contract': contractId,
					'contractActorGroup.reference': 'CONTRACT_ACTOR_GROUP_COMMERCIAL',
				})
				.list()
				.then(async () => {
					await this.commercialStaffMemberCollection
						.listByFromCollection(this.commercialContractActorCollection, 'actorId', 'id');

					await this.commercialStaffCollection
						.listBy(this.commercialStaffMemberCollection.map(m => m.getId('staff')));
				}),

			this.accReportingRecipientContractActorCollection
				.setFilters({
					'contract': contractId,
					'contractActorGroup.reference': 'CONTRACT_ACTOR_GROUP_ACC_REPORTING_RECIPIENT',
				})
				.list()
				.then(async () => {
					await this.accReportingRecipientContractActorContactCollection
						.listByFromCollection(this.accReportingRecipientContractActorCollection, 'actorId', 'id');
				}),
		]);
	};

	public loadBillingAndInvoicingInformations = () => {
		this.billingGroupCollection.clear();
		this.contractIterationBillingGroup.clear();
		this.invoicingGroup.clear();

		if (this.contractIteration.contractIterationBillingGroupId) {
			return this.contractIterationBillingGroup
				.setId(this.contractIteration.contractIterationBillingGroupId)
				.fetch()
				.then(() => {
					this.billingGroupCollection
						.setFilter('sourceUrn', this.contractIterationBillingGroup.urn)
						.list()
						.then(() => {
							this.billableCollection
								.listByFromCollection(this.billingGroupCollection, 'id', 'billingGroup', {}, {
									'billableStatus.reference': [BILLABLE_STATUS_CREATED.reference],
								})
								.then(() => {
									this.billableItemCollection
										.listByFromCollection(this.billableCollection, 'id', 'billable').then();
								});
						})
						.catch(() => {
							// the user could not have the right to get billables
						});

					if (this.contractIterationBillingGroup.getId('invoicingGroup')) {
						this.invoicingGroup.setId(this.contractIterationBillingGroup.getId('invoicingGroup'));
						this.invoicingGroup.fetch().then();
					}
				});
		}
	};

	public loadContractIterationStatusHistoryCollection = () => {
		return this.contractIterationStatusHistoryCollection
			.setFilter('contractIteration', this.contractIteration.id)
			.setSort('createdAt', false)
			.list()
			.then(async () => {
				await this.staffMemberCollection
					.listByFromCollection(this.contractIterationStatusHistoryCollection, 'createdById', 'id');
				await this.staffCollection.listBy(this.staffMemberCollection.map(m => m.getId('staff')));
			});
	};

	public loadInvoiceCollection = () => {
		return Promise.all([
			this.allInvoiceInvoiceCollection
				.setFilters({
					'billingGroup.billingGroupMetas.reference': 'contract_iteration_urn',
					'billingGroup.billingGroupMetas.value': this.contractIteration.urn,
					'invoiceType.reference': 'invoice',
				})
				.list(),

			this.invoiceInvoiceCollection
				.setFilters({
					'billingGroup.billingGroupMetas.reference': 'contract_iteration_urn',
					'billingGroup.billingGroupMetas.value': this.contractIteration.urn,
					'invoiceType.reference': 'invoice',
				})
				.setSort('date')
				.list(),

			this.allInvoiceRefundCollection
				.setFilters({
					'billingGroup.billingGroupMetas.reference': 'contract_iteration_urn',
					'billingGroup.billingGroupMetas.value': this.contractIteration.urn,
					'invoiceType.reference': 'refund',
				})
				.list(),

			this.invoiceRefundCollection
				.setFilters({
					'billingGroup.billingGroupMetas.reference': 'contract_iteration_urn',
					'billingGroup.billingGroupMetas.value': this.contractIteration.urn,
					'invoiceType.reference': 'refund',
				})
				.setSort('date')
				.list(),
		]);
	};

	public loadNotManageableCollections = () => {
		this.operationCategoryCollection
			.setFilter('operationTypes.operations.partitionUrn', ConfigProxy.get('PARTITION_URN'));

		return Promise.all([
			this.billableStatusCollection.list({ cache: 3600 }),
			this.billingFrequencyCollection.list({ cache: 3600 }),
			this.chargeableCollection.list({ cache: 3600 }),
			this.chargeableModeCollection.list({ cache: 3600 }),
			this.contractActorGroupCollection.list({ cache: 3600 }),
			this.activityCategoryCollection.list({ cache: 3600 }),
			this.contractIterationStatusCollection.list({ cache: 3600 }),
			this.currencyCollection.list({ cache: 3600 }),
			this.interventionStatusCollection.list({ cache: 3600 }),
			this.invoiceStatusCollection.list({ cache: 3600 }),
			this.invoiceTypeCollection.list({ cache: 3600 }),
			this.operationCategoryCollection.list({ cache: 3600 }),
			this.paymentModeTypeCollection.list({ cache: 3600 }),
			this.taskOperationStatusCollection.list({ cache: 3600 }),
			this.taskStatusCollection.list({ cache: 3600 }),
			this.vatCollection.list(),
		]);
	};

	public loadProofConvention = async () => {
		if (this.isAcc) {
			await this.proofConventionFileCollection
				.setFilters({
					'typeSource.source.entityUrn': this.contractIteration.urn,
					'typeSource.type.reference': 'contract_iteration_proof_convention',
				})
				.list();
		}
	};

	@computed
	public get contractIterationItemActivityByTaskZoneUrn() {
		return groupCollectionByProperty(this.contractIterationItemActivityCollection, 'locationUrn');
	}

	@computed
	public get activityById() {
		return indexCollectionByProperty(this.activityCollection, 'id');
	}

	@computed
	public get chargeableById() {
		return indexCollectionByProperty(this.chargeableCollection, 'id');
	}

	@computed
	public get contractIterationItemActivityByContractIterationItemId() {
		return groupCollectionByProperty(this.contractIterationItemActivityCollection, 'contractIterationItem.id');
	}

	@computed
	public get contractIterationItemActivityTagByContractIterationItemActivityUrn() {
		return groupCollectionByProperty(this.contractIterationItemActivityTagCollection, 'targetUrn');
	}

	@computed
	public get contractIterationItemActivityChargeableByContractIterationItemActivityId() {
		return groupCollectionByProperty(this.contractIterationItemActivityChargeableCollection, 'contractIterationItemActivity.id');
	}

	@computed
	public get contractIterationItemEventByContractIterationItemId() {
		return groupCollectionByProperty(this.contractIterationItemEventCollection, 'contractIterationItem.id');
	}

	@computed
	public get contractIterationItemScheduleConstraintByContractIterationItemId() {
		return groupCollectionByProperty(this.contractIterationItemScheduleConstraintCollection, 'contractIterationItem.id');
	}

	@computed
	public get contractIterationIsUpdatable() {
		return Rights.contractIteration.isUpdatable(this.contractIterationStatus);
	}

	@computed
	public get contractIterationEventsAreUpdatable() {
		return Rights.contractIteration.eventsAreUpdatable(this.contractIterationStatus);
	}

	@computed
	public get contractIterationActivitiesVatsAreUpdatable() {
		return Rights.contractIteration.activitiesVatsAreUpdatable(this.contractIterationStatus);
	}

	@computed
	public get contractIterationTotalPriceExclTaxWithoutDiscount() {
		return this.contractIteration.totalPriceExclTax;
	}

	@computed
	public get contractIterationTotalPriceExclTaxWithDiscount() {
		return this.contractIteration.totalPriceExclTax
			- (this.contractIteration.totalPriceExclTax * this.contractIteration.discount / 100);
	}

	@computed
	public get billingGroup() {
		return this.billingGroupCollection.last();
	}

	@computed
	public get billingFrequency() {
		const billingFrequency = this.billingFrequencyCollection.find(
			billingFrequency => billingFrequency.id === this.contractIterationBillingGroup.getId('billingFrequency'),
		);

		if (!billingFrequency) {
			return new BillingFrequencyModel();
		}

		return billingFrequency;
	}

	@computed
	public get contractIterationStatus() {
		const contractIterationStatus = this.contractIterationStatusCollection.find(
			contractIterationStatus => contractIterationStatus.iri === this.contractIteration.contractIterationStatusIri,
		);

		if (!contractIterationStatus) {
			return new ContractIterationStatusModel();
		}

		return contractIterationStatus;
	}

	@computed
	public get contractOrigin() {
		return this.contractOriginCollection.first() || undefined;
	}

	@computed
	public get contractIterationClosing() {
		return this.contractIterationClosingCollection.first() || undefined;
	}

	@computed
	public get contractIterationStatusHistoryValidatedByClient() {
		const validatedByClientStatus = this.contractIterationStatusCollection.find(
			contractIterationStatus => contractIterationStatus.reference ===
				'validated_by_client',
		);

		if (!validatedByClientStatus) {
			return new ContractIterationStatusHistoryModel();
		}

		const contractIterationStatusHistoryValidatedByClient = this.contractIterationStatusHistoryCollection.find(
			contractIterationStatusHistory => contractIterationStatusHistory.contractIterationStatusId === validatedByClientStatus.id,
		);

		if (!contractIterationStatusHistoryValidatedByClient) {
			return new ContractIterationStatusHistoryModel();
		}

		return contractIterationStatusHistoryValidatedByClient;
	}

	@computed
	public get staffContractActor() {
		const lastStaffContractActor = this.commercialContractActorCollection.last();

		if (!lastStaffContractActor) {
			return new ContractActorModel();
		}

		return lastStaffContractActor;
	}

	public set contractIterationId(contractIterationId) {
		this._contractIterationId = contractIterationId;
		this.load().then();
	}

	@computed
	public get totalStucked() {
		return this.contractIterationItemEventDonePendingCollection.models.reduce(
			(previousValue, val) => {
				const contractIterationItem = this.contractIterationItemCollection
					.getById(val.getId('contractIterationItem'));

				if (!contractIterationItem) {
					return previousValue;
				}

				const totalActivities = this.contractIterationItemActivityCollection.models.reduce(
					(previousValue, currentValue) => {
						if (currentValue.getId('contractIterationItem') !== contractIterationItem.id) {
							return previousValue;
						}

						return previousValue + currentValue.totalPriceExclTax;
					},
					0,
				);

				return previousValue + totalActivities;
			},
			0,
		);
	}

	@nestedResolvable()
	public get contract() {
		return this.contractIteration.contract;
	}

	@nestedResolvable()
	public get owner() {
		return this.contractIteration.contract.owner;
	}

	@nestedResolvable()
	public get client() {
		return this.contractIteration.contract.owner.client;
	}

	@computed
	public get taskZonesWithoutContactSignatory() {
		const taskZones: TaskZoneModel[] = [];
		if (!this.zoneContactCollection.length) {
			return taskZones;
		}

		this.taskZoneCollection.forEach(tz => {
			if (!this.zoneContactCollection.find(zc => zc.taskZoneId === tz.id)) {
				taskZones.push(tz);
			}
		});

		return taskZones;
	}

	@computed
	public get reconductability() {
		return this.reconductabilityCollection.first();
	}

	@computed
	public get proofConvention() {
		return this.proofConventionFileCollection.first();
	}

	@computed
	public get isAcc() {
		return this.contract.activityCategory.reference === 'acc';
	}

	public get itemListNeedsReload() {
		return this._itemListNeedsReload;
	}

	public get marginNeedsReload() {
		return this._marginNeedsReload;
	}

	public get participationNeedsReload() {
		return this._participationNeedsReload;
	}

	@action
	public setItemListNeedsReload = (itemListNeedsReload: boolean) => {
			this._itemListNeedsReload = itemListNeedsReload;
		};

	@action
	public setMarginNeedsReload = (marginNeedsReload: boolean) => {
			this._marginNeedsReload = marginNeedsReload;
		};

	@action
	public setParticipationNeedsReload = (participationNeedsReload: boolean) => {
			this._participationNeedsReload = participationNeedsReload;
		};

	@computed
	public get summary() {
		return this.contractIterationSummaryCollection.first();
	}

	@computed
	public get summaryCalculateProjected(){
		return new ContractIterationSummaryCalculateProjectedModel({ id: this.summary?.id });
	}

	@computed
	public get offer() {
		return this.contractIteration;
	}
}
